export default __webpack_public_path__ + "ecf38f2caaf7f08f34f75225f1f0814d.png";